import { render, staticRenderFns } from "./PeopleItem.vue?vue&type=template&id=76c76f1a&scoped=true"
import script from "./PeopleItem.vue?vue&type=script&lang=js"
export * from "./PeopleItem.vue?vue&type=script&lang=js"
import style0 from "./PeopleItem.vue?vue&type=style&index=0&id=76c76f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c76f1a",
  null
  
)

export default component.exports